import { talentsEndpoints } from './talents';
import { catalogEndpoints } from './catalog';
import { moderationEndpoints } from './moderation';
import { organizationsEndpoints } from './organizations';
import { analyticsEndpoints } from './analytics';
import { billingEndpoints } from './billing';
import { settingsEndpoints } from './settings';
import { adminsEndpoints } from './admins';
import { supportEndpoints } from './support';

export { adminApi } from './auth';

/**
 * The two reads the dashboard makes that are not about the admin themselves.
 *
 * `searchTalents` is deliberately uncached — an admin who has just verified
 * somebody reloads the list to see it, and a stale answer would show them the
 * state they were trying to change. `listSpecialties` is reference data that
 * changes with a deploy, so the query layer holds it for five minutes rather
 * than refetching it per screen.
 */
export const consoleApi = {
  ...talentsEndpoints,
  ...catalogEndpoints,
  ...moderationEndpoints,
  ...organizationsEndpoints,
  ...analyticsEndpoints,
  ...billingEndpoints,
  ...settingsEndpoints,
  ...adminsEndpoints,
  ...supportEndpoints,
};
